import React, { useEffect, useState } from 'react';
import AddFormButton from './AddFormButton';
import FormCard from './FormCard';
import SubdepartmentParent from './SubdepartmentParent';

const LABELS = ['Order', 'Field Label', 'Field Type', 'Required', 'Field Access', 'Hide for', 'DependsOn', 'Options'];
const sampleFields = [
  { id: 1, order: 1, fieldLabel: 'Department', fieldType: 'Custom', required: false, fieldAccess: '', hideFor: ['Level 1', 'Level 2'], dependsOn: '', options: ['Low', 'High'] },
  { id: 2, order: 2, fieldLabel: 'Sub-department', fieldType: 'Custom', required: false, fieldAccess: '', hideFor: [], dependsOn: 'Department', options: ['Payroll', 'Recruitment'] },
];

function normalizeField(field, index) {
  return {
    id: field.id ?? `${Date.now()}-${index}`,
    order: index + 1,
    fieldLabel: field.fieldLabel ?? field.name ?? '',
    fieldType: field.fieldType ?? field.typeLabel ?? 'Custom',
    required: Boolean(field.required),
    fieldAccess: field.fieldAccess ?? '',
    hideFor: field.hideFor ?? [],
    dependsOn: field.dependsOn ?? '',
    options: field.options ?? [],
  };
}

export default function FormCardGrid({ initialFields, onChange, fieldToAdd }) {
  const [fields, setFields] = useState(() => (initialFields?.length ? initialFields : sampleFields).map(normalizeField));
  const commit = (nextFields) => { setFields(nextFields); onChange?.(nextFields); };
  useEffect(() => {
    if (!fieldToAdd) return;
    setFields((currentFields) => {
      const nextFields = [...currentFields, normalizeField({ ...fieldToAdd, id: `${fieldToAdd.id}-${Date.now()}` }, currentFields.length)];
      onChange?.(nextFields);
      return nextFields;
    });
  }, [fieldToAdd, onChange]);
  const updateField = (updatedField) => commit(fields.map((field) => field.id === updatedField.id ? updatedField : field));
  const deleteField = (id) => commit(fields.filter((field) => field.id !== id).map((field, index) => ({ ...field, order: index + 1 })));
  const addField = () => commit([...fields, normalizeField({ id: `${Date.now()}-${fields.length}`, fieldLabel: '', fieldType: 'Custom', options: [] }, fields.length)]);
  const labels = fields.map((field) => field.fieldLabel).filter(Boolean);

  return (
    <div className="ca-form-card-grid__container ">
    <div className="ca-form-card-grid">
      <div className="ca-form-card-grid__labels">
        {LABELS.map((label) => <div key={label} className="ca-form-card-grid__label">{label}</div>)}
      </div>
      <div className="ca-form-card-grid__cards">
        {fields.map((field) => (
          <FormCard key={field.id} field={field} fieldOptions={labels.filter((label) => label !== field.fieldLabel)} onChange={updateField} onDelete={deleteField} />
        ))}
        <AddFormButton onAdd={addField} />
      </div>
        
    </div>
        <SubdepartmentParent formFields={fields}/>

        </div>
  );
}